import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {
    savePreset,
} from 'components/v2/trackRightClickActions.js';
import ContextMenu from "components/dropdowns/ContextMenu.js";
import MenuItem from "components/dropdowns/MenuItem.js";

const TrackContextMenu = ({setDropdownPos, dropdownPos,track}) => { 
    const duplicate = useCallback(() => {
        track.sequencerEngine.duplicateTrack(track.trackNumber);
        setDropdownPos(undefined);
    }, [track, setDropdownPos]);

    const copyStepsToAll = useCallback(() => {
        for (let i=0; i < track.patterns.length; i++ ){
            if (i===track.currentPattern) {
                continue;
            }
            let pattern = track.pattern.getCopy();
            track.patterns[i] = pattern;
            track.pattern.syncBuckets();
        }

        setDropdownPos(undefined);
    }, [track, setDropdownPos]);

    const _savePreset = useCallback(() => {
        savePreset(track);
        setDropdownPos(undefined);
    }, [track, setDropdownPos]);

    return (
        <ContextMenu dropdownPos={dropdownPos} setDropdownPos={setDropdownPos}>
          <MenuItem onMouseDown={duplicate}>
            Duplicate <div className="key-shortcut">⌘D</div>
          </MenuItem>
          <MenuItem onMouseDown={_savePreset}>
            Save Preset
          </MenuItem>
          <MenuItem onMouseDown={copyStepsToAll}>
            Copy Steps to All Patterns
          </MenuItem>
        </ContextMenu>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackContextMenu);
